import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import { AsyncRenderer } from '../../components/AsyncRenderer/AsyncRenderer';
import { useBundlesVM } from './viewModel/bundles.viewModel';
import { BundlesView } from './view/BundlesView';
import { PageWrapper } from './view/PageWrapper';

export const BundlesManagementPage = (p: {
  params: { influencerId: string };
}) => {
  const creatorId = parseInt(p.params.influencerId) || 0;
  const vm = useBundlesVM({ creatorId });

  return (
    <PageWrapper>
      <AsyncRenderer
        data={vm}
        loadRender={<Loader />}
        renderer={(data) => <BundlesView {...data} />}
      />
    </PageWrapper>
  );
};

const Loader = () => (
  <div className="mt-[90px]">
    <TableLoader rows={5} height={130} />
  </div>
);
